import { createFileRoute } from '@tanstack/react-router'
import SharedOpportunityDetail from '@/views/SharedOpportunityDetail'

export const Route = createFileRoute('/issues/shared/$token')({
  component: RouteComponent,
})

function RouteComponent() {
  const { token } = Route.useParams()
  return <SharedOpportunityDetail token={token} />
}
